import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import RmaReasonsState from "@store/Store/Data/RmaReasons/RmaReasonsState";
import { Draft } from "immer";

const initialState: RmaReasonsState = {
    rmaReasons: [],
};

const reducer = {
    "Data/RmaReasons/RmaReasons": (draft: Draft<RmaReasonsState>, action: any) => {
        if (action.parameter.successful === false || action.parameter.result.length === 0) {
            draft.rmaReasons = [];
        } else {
            draft.rmaReasons = action.parameter.result;
        }
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
